import { connect } from 'react-redux'
import * as TackLikesActions from '../../stores/tack_likes/actions';
import * as UserTacksActions from '../../stores/user_tacks/actions';
import TackBoardFinishedTacks from '../../components/tack_board/tack_board_finished_tacks';

const mapStateToProps = (state) => {
  return {
    userTacks: state.default.userTacks,
    user: state.default.user
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onFetchFinishedTacks: () => {
      dispatch(UserTacksActions.done());
    },
    onLikeTack: (tackSlug) => {
      dispatch(TackLikesActions.like(tackSlug));
    },
    onUnLikeTack: (tackSlug) => {
      dispatch(TackLikesActions.unLike(tackSlug));
    },
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(TackBoardFinishedTacks);



// WEBPACK FOOTER //
// ./src/containers/tack_board/tack_board_finished_tacks.js